export default "__VITE_ASSET__CpJj0T5g__$_?no-inline__"